import type { ProviderRow } from "@/app/types/Provider";
import { formatSkAppointmentLuxon } from "../../lib/date-time";
import { getProviderDisplayName } from "../../lib/providerName";
import Button from "@/app/components/Button";

export function BookingSuccess({
  slotUTC,
  providers,
  providerId,
  onNewBooking,
  hasMail,
  email,
  smsPhone,
}: {
  slotUTC: string;
  providers: ProviderRow[];
  providerId: string;
  onNewBooking: () => void;
  hasMail: boolean;
  email?: string;
  /** The number the SMS confirmation went to, when one did. */
  smsPhone?: string;
}) {
  const doctorName = getProviderDisplayName(providers.find((p) => p.id === providerId));
  const summary = formatSkAppointmentLuxon(slotUTC);

  return (
    <div style={{ textAlign: "center", padding: "24px 8px 8px" }}>
      <div style={{ width: 74, height: 74, borderRadius: "50%", background: "var(--ok-tint)", color: "var(--ok)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
        <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6 9 17l-5-5" />
        </svg>
      </div>
      <h2 style={{ fontWeight: 800, fontSize: "clamp(23px, 6vw, 30px)", letterSpacing: "-0.02em", margin: "0 0 10px", color: "var(--ink)" }}>
        Rezervácia odoslaná
      </h2>
      <p style={{ color: "var(--ink-soft)", fontSize: 15, lineHeight: 1.65, maxWidth: 430, margin: "0 auto" }}>
        Termín <strong style={{ color: "var(--ink)" }}>{summary}</strong> u {doctorName} je rezervovaný.
        {hasMail && email && (
          <> Potvrdenie sme poslali na <strong style={{ color: "var(--ink)" }}>{email}</strong>.</>
        )}
        {!(hasMail && email) && smsPhone && (
          <> Potvrdenie sme poslali SMS správou na <strong style={{ color: "var(--ink)" }}>{smsPhone}</strong>.</>
        )}
      </p>
      <Button variant="themed" onClick={onNewBooking} data-testid="new-booking-button" style={{ marginTop: 24, fontSize: 15, padding: "15px 30px", borderRadius: 13, fontWeight: 700 }}>Späť na stránku</Button>
    </div>
  );
}
